export default __webpack_public_path__ + "static/media/Akthe_m_1112.eb411789.png";